<script lang="ts">
  import { store } from '$lib/store.svelte';
  import { formatDate } from '$lib/gtd';

  interface Props { onMessage: (m: string, t?: 'success' | 'warning') => void }
  let { onMessage }: Props = $props();

  const RESTAURABLES = ['texto', 'notas', 'tags', 'relacionadas', 'estado'];

  async function act(fn: () => Promise<unknown>) {
    try { await fn(); } catch (e) { onMessage(e instanceof Error ? e.message : String(e), 'warning'); }
  }

  function cambiosDeAgentes(id: string) {
    const idea = store.ideas.find((i) => i.id === id)!;
    return idea.historial
      .map((h, index) => ({ h, index }))
      .filter(({ h }) => h.autor !== 'carlos')
      .slice(-5)
      .reverse();
  }
</script>

<div class="view-title">Tocado por agentes</div>
<p class="view-sub">Cambios de JARVIS, Mercurius y Grok que todavía no viste.</p>

{#if store.pendientes.length === 0}
  <div class="empty"><div class="empty-title">Nada pendiente</div></div>
{:else}
  {#each store.pendientes as idea (idea.id)}
    <div class="item" style="display:block">
      <div class="item-text">{idea.texto}</div>
      {#each cambiosDeAgentes(idea.id) as { h, index }}
        <div class="item-meta" style="display:flex;gap:var(--space-xs);align-items:center">
          <span>{formatDate(h.fecha)} · <strong>{h.autor}</strong> · {h.accion}{h.campo ? ` ${h.campo}` : ''}{h.motivo ? ` — ${h.motivo}` : ''}
            {#if h.campo && h.accion !== 'capturar'} (antes: {JSON.stringify(h.anterior)}){/if}</span>
          {#if RESTAURABLES.includes(h.campo) && !(h.campo === 'estado' && (h.anterior === 'promovida' || idea.estado === 'promovida'))}
            <button type="button" class="btn btn-secondary" onclick={() => act(() => store.restaurarIdea(idea.id, index))}>Deshacer</button>
          {/if}
        </div>
      {/each}
      <button type="button" class="btn btn-primary" onclick={() => act(() => store.marcarRevisadoIdea(idea.id))}>Visto</button>
    </div>
  {/each}
{/if}
